import { cloneDeep } from 'lodash-es';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigurationService {
  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  apiUrl = '';

  // Whether or not to enable debug mode
  enableDebug = false;

  environment = {
    production: false,

    apiUrl: '', // Basicly the scip service url.
    baseUrl: '', // the url where anglar application is running. Used when we try to do the sielent refresh.
    translationsUri: '',
    authConfig: {
      baseUri: '',
      userUri: '',
      redirectUri: '',
      accessTokenUri: '',
      infoUri: '',
      clientId: '',
      requireHttps: false,
      showDebugInformation: true,
      useSilentRefresh: true,
      oidc: true,
      scope: 'openid',
      responseType: 'code',
      clearHashAfterLogin: true
    },

    allowRolesFeature: false,
    loggingLevel: 'Warning',
    canEditArticleIdentifier: false,
    showVDACats: true,
    showSUIRolledUp: true,
    scipVersion: '',
    allowForceResubmission: true,

    // Autosaving user settings
    // We autosave some ui user settings, to not DoS our backend lets throttle it to combine multiple changes into one call
    uiSettingsAutoSaveThrottleTimeInMs: 1000,

    // Features
    // Features we enable/disable based on a license
    feature: {
      leGrouping: false
    },
    // Used to disable the dashboard if it is not wanted
    dashboardHidden: false,
    // Used temporarily as a way to set a custom logo within the banner on the dashboard
    dashboardBannerLogoUrl: '',
    // Used if e.g. QA/Testing-environments should have an indicator in the app header
    systemRibbon: '',
    // Use to setup default OAI
    defaultOAI: '66306'
  };

  // This will contain the resolved environment in case it was changed during the creation of the service instance
  private _defaultEnvironment = {};

  constructor() {
    this._defaultEnvironment = cloneDeep(this.environment);
  }

  get defaultEnvironment(): any {
    return this._defaultEnvironment;
  }
}
